module.exports = __webpack_public_path__ + "img/webchat.a051ad70.png";